module.exports = __webpack_public_path__ + "static/img/img_15.b6698575.png";